// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tutorial-parent-header {
  margin-top: 3%;
}

.tutorial-card-container {
  margin-bottom: 5%;
}

.tutorial-header-text {
  font-size: 50px;
}

@media only screen and (max-width: 767px) {
  .tutorial-steps-header {
    font-size: 40px !important;
  }
  .tutorial-card-container {
    margin-top: -10%;
  }
}
@media only screen and (max-width: 576px) {
  .tutorial-header-text {
    font-size: 30px !important;
  }
  .tutorial-card-container {
    margin-top: -10%;
  }
}
@media only screen and (max-width: 440px) {
  .tutorial-header-text {
    font-size: 30px !important;
    margin: 5% 5% !important;
  }
  .tutorial-card-container {
    margin-top: -10%;
  }
}`, "",{"version":3,"sources":["webpack://./src/presentation/main/wishlist/components/wish-tut/tutorial.scss"],"names":[],"mappings":"AAEA;EACI,cAAA;AADJ;;AAIA;EACI,iBAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAIA;EAEI;IACI,0BAAA;EAFN;EAIE;IACI,gBAAA;EAFN;AACF;AAME;EAEE;IACI,0BAAA;EALN;EAOE;IACI,gBAAA;EALN;AACF;AAQE;EAEE;IACI,0BAAA;IACA,wBAAA;EAPN;EAUE;IACI,gBAAA;EARN;AACF","sourcesContent":["\n\n.tutorial-parent-header{\n    margin-top:3%;\n}\n\n.tutorial-card-container{\n    margin-bottom:5%;\n}\n\n.tutorial-header-text{\n    font-size:50px;\n}\n\n@media only screen and (max-width: 767px) {\n  \n    .tutorial-steps-header{\n        font-size:40px !important;\n    }\n    .tutorial-card-container{\n        margin-top: -10%;\n    }\n  }\n\n\n  @media only screen and (max-width: 576px) {\n  \n    .tutorial-header-text{\n        font-size:30px !important;\n    }\n    .tutorial-card-container{\n        margin-top: -10%;\n    }\n  }\n\n  @media only screen and (max-width: 440px) {\n  \n    .tutorial-header-text{\n        font-size:30px !important;\n        margin:5% 5% !important\n       \n    }\n    .tutorial-card-container{\n        margin-top: -10%;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
